// extracted by mini-css-extract-plugin
export default {"root":"QuoteItem__root--Uh7B8","left":"QuoteItem__left--p3ex1","row-title":"QuoteItem__row-title--o6scQ","rowTitle":"QuoteItem__row-title--o6scQ","right":"QuoteItem__right--YtbfC"};